export const  QuestionCard = ({ 
	no, 
	title,
	description, 
	children }:{
    no: number,
    title: string,
    description: string | null,
	children: React.ReactNode
}) => {
	return (
		<div className="survey-form__item">
			<div className="survey-form__topic">
				<div className="survey-form__topic-item">
					<span className="survey-form__topic-require"></span>
					<span className="survey-form__topic-number">{no}</span>
				</div>
				<div className="survey-form__topic-title">
					{title}
					{description ? (
						<div className="survey-form__topic-legend">
							{description}
						</div>
					) : null}
				</div>
				
			</div>
			{children}
		</div>
	)
}